<div class="settings-modal-dialog__wrapper">
  <h1 mat-dialog-title>
    <i class="fas fa-users-cog i-18 mr-6"></i>
    <span class="fs-18">Settings</span>
    <button trgButton class="dialog-close-btn manage-profile-close" (click)="close()">
      <i class="fal fa-times i-12 p-relative ot-1 manage-profile-x"></i>
    </button>
  </h1>
  <div mat-dialog-content class="manage-profile-container d-flex">
    <ng-container>
      <div class="manage-profile-selector mr-15 fs-14">
        <div [class.selected]="selectedTabIndex == 0"
             (click)="selectedTabIndex = 0"
             class="d-flex align-items-center h-30 mb-5 justify-content-between pointer">
          <div class="d-flex h-100p align-items-center">
            <div class="manage-profile-selector-bar"></div>
            <span>General</span>
          </div>
          <i *ngIf="selectedTabIndex == 0" class="fas fa-chevron-right mr-15"></i>
        </div>
        <div [class.selected]="selectedTabIndex == 1"
             (click)="selectedTabIndex = 1"
             class="d-flex align-items-center h-30 mb-5 justify-content-between pointer">
          <div class="d-flex h-100p align-items-center">
            <div class="manage-profile-selector-bar"></div>
            <span>Region</span>
          </div>
          <i *ngIf="selectedTabIndex == 1" class="fas fa-chevron-right mr-15"></i>
        </div>
        <div *ngIf="!businessUser()"
             [class.selected]="selectedTabIndex == 2"
             (click)="selectedTabIndex = 2"
             class="d-flex align-items-center h-30 mb-5 justify-content-between pointer">
          <div class="d-flex h-100p align-items-center">
            <div class="manage-profile-selector-bar"></div>
            <span>Notifications</span>
          </div>
          <i *ngIf="selectedTabIndex == 2" class="fas fa-chevron-right mr-15"></i>
        </div>
      </div>
      <div class="manage-profile-holder">
        <div *ngIf="selectedTabIndex == 0" class="manage-profile-general">
          <div class="manage-profile-title d-flex w-100p pb-5 pt-6"><span class="fs-14 bold">General</span></div>
          <div class="manage-profile-list mt-10">
            <div class="manage-profile-list-item">
              <div class="main c-grey-5 fs-14 bold manage-profile-list-item-title">Name:</div>
              <div class="main c-grey-5 fs-12 ml-8">{{userClaims.name}}</div>
            </div>
            <div class="manage-profile-list-item">
              <div class="main c-grey-5 fs-14 bold manage-profile-list-item-title">User Name:</div>
              <div class="main c-grey-5 fs-12 ml-8">{{userClaims.email}}</div>
            </div>
            <div class="manage-profile-list-item">
              <div class="main c-grey-5 fs-14 bold manage-profile-list-item-title">Organisation:</div>
              <div class="main c-grey-5 fs-12 ml-8">{{userClaims.organisation}}</div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTabIndex == 1" class="manage-profile-region">
          <div class="manage-profile-title d-flex w-100p pb-5 pt-6"><span class="fs-14 bold">Region</span></div>

          <div class="manage-profile-block mt-24">
            <div class="manage-profile-section-title fs-12 pb-7 mb-5 bold">Number/Date Format</div>
            <div class="manage-profile-list">
              <div class="manage-profile-list-item c-grey-5">
                <div class="main c-grey-5 fs-12 bold manage-profile-list-item-title region-title">Set Region:</div>
                <div class="fs-12 locale-dropdown-container locale-dropdown-panel">
                  <mat-select [(ngModel)]="selectedLocale"
                              panelClass="locale-dropdown disable-scroll move-dropdown trg-outline-dropdown"
                              class="trg-outline h-26 lh-26"
                              [disableOptionCentering]="false">
                    <mat-select-trigger>{{selectedLocale.name}}</mat-select-trigger>
                    <div class="disable-scroll">
                      <div class="dropdown-header fs-10">
                        <div class="dropdown-region">Region</div>
                        <div>Format Example</div>
                      </div>
                      <div class="enable-scroll">
                        <mat-option *ngFor="let l of locales()" [value]="l" class="locale-option">
                          <div class="locale-item">
                            <div class="pl-10 fs-12 locale-name">{{l.name}}</div>
                            <div class="locale-date fs-10">{{l.formats.timestamp.date}}</div>
                            <div class="locale-time fs-10">{{l.formats.timestamp.time}}</div>
                            <div class="locale-number fs-10">{{l.numberFormatExample}}</div>
                          </div>
                        </mat-option>
                      </div>
                    </div>
                  </mat-select>
                  <div class="locale-info" *ngIf="selectedLocale">
                    {{selectedLocale.formats.timestamp.date}}&nbsp;&nbsp;&nbsp;{{selectedLocale.formats.timestamp.time}}&nbsp;&nbsp;&nbsp;{{selectedLocale.numberFormatExample}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="manage-profile-block mt-15" *ngIf="!businessUser()">
            <div class="manage-profile-section-title fs-12 pb-7 mb-5 bold">Time Zone</div>
            <div class="manage-profile-list">
              <div class="manage-profile-list-item c-grey-5">
                <div class="main c-grey-5 fs-12 bold manage-profile-list-item-title region-title">Set Time Zone:</div>
                <div class="fs-12 locale-dropdown-container locale-dropdown-panel">
                  <mat-select [(ngModel)]="selectedTimeZone"
                              panelClass="timezone-dropdown disable-scroll move-dropdown trg-outline-dropdown"
                              class="trg-outline h-26 lh-26"
                              [disableOptionCentering]="false">
                    <mat-select-trigger>
                      <span *ngIf="selectedTimeZone">(UTC{{selectedTimeZone.offsetString}}) {{selectedTimeZone.name}}</span>
                    </mat-select-trigger>
                    <div class="disable-scroll">
                      <div class="dropdown-header fs-10">
                        <div class="dropdown-tz">Time Zone</div>
                      </div>
                      <div class="enable-scroll">
                        <mat-option *ngFor="let tz of timeZones" [value]="tz" class="locale-option">
                          <div class="locale-item">
                            <div class="pl-10 fs-12 locale-tz-name">(UTC{{tz.offsetString}}) {{tz.name}}</div>
                          </div>
                        </mat-option>
                      </div>
                    </div>
                  </mat-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTabIndex == 2 && !businessUser()" class="manage-profile-notifs">
          <div class="manage-profile-title d-flex w-100p pb-5 bold pt-6">
            <span class="fs-14 bold">Notifications</span>
            <trg-toggle color="green"
                        class="ml-35"
                        [value]="notificationsEnabled"
                        (valueChange)="notificationsEnabled = !notificationsEnabled; dirty = true"></trg-toggle>
          </div>
          <div class="manage-profile-block mt-24">
            <div class="manage-profile-section-title fs-12 pb-7 mb-10 bold">All Notifications</div>
            <div class="manage-profile-list flex-dir-row h-24">
              <ng-container *ngTemplateOutlet="notifSubsection; context: {section: sections[0], main: true}"></ng-container>
            </div>
            <div class="manage-profile-list flex-dir-row mt-10 h-24">
              <div class="manage-profile-list-item c-grey-5 mb-0 mr-50">
                <div class="main c-grey-5 fs-12 bold manage-profile-list-item-title">Toast Position:</div>
                <div class="fs-12 position-dropdown-panel">
                  <mat-select [ngModel]="toastViewPortLocation"
                              (ngModelChange)="toastService.overrideOrientation(toastViewPortLocation = $event); dirty = true"
                              panelClass="trg-outline-dropdown"
                              [disableOptionCentering]="false"
                              [disabled]="!notificationsEnabled"
                              class="h-24 lh-24 w-200 trg-outline">
                    <mat-select-trigger>{{toastLocationIndexDisplayName()}}</mat-select-trigger>
                    <mat-option [value]="2">
                      Bottom Right
                      <span class="fs-12">(Default)</span>
                    </mat-option>
                    <mat-option [value]="3">Bottom Left</mat-option>
                    <mat-option [value]="0">Top Right</mat-option>
                    <mat-option [value]="1">Top Left</mat-option>
                  </mat-select>
                </div>
                <span class="fs-10 pl-10 c-blue underline pointer" (click)="previewToast()">Preview</span>
              </div>
            </div>
          </div>
          <div class="manage-profile-block mt-24">
            <div class="manage-profile-section-title fs-12 pb-7 mb-10 bold">Unlocked Notifications</div>
            <div class="manage-profile-list flex-dir-row h-24">
              <ng-container *ngTemplateOutlet="notifSubsection; context: {section: sections[1], main: false}"></ng-container>
            </div>
          </div>
          <div class="manage-profile-block mt-24">
            <div class="manage-profile-section-title fs-12 pb-7 mb-10 bold">Extended Dataset has finished Loading</div>
            <div class="manage-profile-list flex-dir-row h-24">
              <ng-container *ngTemplateOutlet="notifSubsection; context: {section: sections[2], main: false}"></ng-container>
            </div>
          </div>
          <div class="manage-profile-block mt-24">
            <div class="manage-profile-section-title fs-12 pb-7 mb-10 bold">Scheduled Report Run Now has completed</div>
            <div class="manage-profile-list flex-dir-row h-24">
              <ng-container *ngTemplateOutlet="notifSubsection; context: {section: sections[3], main: false}"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div mat-dialog-actions align="end" class="settings-modal-dialog__bottom">
    <button trgButton color="outline" class="min-w-100 c-blue manage-profile-cancel" (click)="close()">Cancel</button>
    <button trgButton color="primary" class="min-w-100" (click)="save()" cdkFocusInitial>Save &amp; Close</button>
  </div>
</div>

<ng-template #notifSubsection let-section="section" let-main="main">
  <div class="manage-profile-list-item c-grey-5 mb-0 bold mr-50">
    <div class="main c-grey-5 fs-12 bold manage-profile-list-item-title">Toast Notification:</div>
    <trg-toggle color="green"
                class="ml-5"
                [value]="section?.toastsEnabled"
                (valueChange)="section.toastsEnabled = !section.toastsEnabled; dirty = true"
                [disabled]="(!sections[0].toastsEnabled && !main) || !notificationsEnabled"></trg-toggle>
  </div>
  <div class="manage-profile-list-item c-grey-5 mb-0 bold mr-50">
    <div class="main c-grey-5 fs-12 bold manage-profile-list-item-title">Notification Panel:</div>
    <trg-toggle color="green"
                class="ml-5"
                [value]="section?.panelEnabled"
                (valueChange)="section.panelEnabled = !section.panelEnabled; dirty = true"
                [disabled]="(!sections[0].panelEnabled && !main) || !notificationsEnabled"></trg-toggle>
  </div>
  <div class="manage-profile-list-item c-grey-5 mb-0 bold mr-50">
    <div class="main c-grey-5 fs-12 bold manage-profile-list-item-title w-50">Sounds:</div>
    <trg-toggle color="green"
                class="ml-5"
                [value]="section?.soundsEnabled"
                (valueChange)="section.soundsEnabled = !section.soundsEnabled; dirty = true"
                [disabled]="(!sections[0].soundsEnabled && !main) || !notificationsEnabled"></trg-toggle>
  </div>
</ng-template>
